import Modal from "@3gaam/shared/components/general/modal";
import { useCallback } from "react";

type Props = {
  showState: boolean;
  setShowState: () => void;
  videoSource: string;
  noTitle?: boolean;
};

export const VideoModal = ({
  setShowState,
  showState,
  videoSource,
  noTitle,
}: Props) => {
  const handleShowModal = useCallback(() => {
    setShowState();
  }, [setShowState]);
  return (
    <div
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <Modal
        setShow={handleShowModal}
        showState={showState}
        noCloseBtn={true}
        bodyClassName="py-4 px-3 px-lg-4 pos-rel"
        size="lg"
      >
        <div className="cns-cv-modal">
          {!noTitle && <h3>معرفی</h3>}
          <div>
            <iframe src={videoSource} />
          </div>
          <button className="btn btn-primary" onClick={handleShowModal}>
            بستن صفحه
          </button>
        </div>
      </Modal>
    </div>
  );
};
